import { gql } from '@apollo/client';

export default gql`
  query onHoldBookings($expiry: String!, $officeLocation: OnHoldOfficeLocationSearchEnum, $filteredOfficeLocation: String) {
    onHoldBookings(expiry: $expiry, officeLocation: $officeLocation, filteredOfficeLocation: $filteredOfficeLocation) {
      reference
      expiryTimestamp
      status
      externalBookingReferences {
        source
        type
        externalId
      }
      agent {
        office
      }
      customer {
        firstName
        lastName
      }
      passengers {
        id
      }
      outbound {
        origin {
          shortCode
          shortName
          name
        }
        destination {
          shortCode
          shortName
          name
        }
        timing {
          isoDate
        }
      }
      inbound {
        origin {
          shortCode
          shortName
          name
        }
        destination {
          shortCode
          shortName
          name
        }
        timing {
          isoDate
        }
      }
    }
  }
`;
